/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import Cookie, { getCookie } from 'utils/cookies';
import makeRequest from 'utils/makeRequest';
import PollSuccessLoginBlocker from '../../../../liveblog_v2/components/common/TimelinePoll/PollSuccessLoginBlocker';
import PollResult from '../../../../liveblog_v2/components/common/TimelinePoll/PollResult';

//import s from './Polls.scss';
import s from '../../../../liveblog_v2/components/common/TimelinePoll/TimelinePoll.scss';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

class Polls extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      showPollResult: false,
      selectedOption: null,
      pollResult: null,
    };
  }
  componentDidMount() {
    try {
      const storedPollSelectionsJSON = localStorage.getItem('pollSelections');
      if (storedPollSelectionsJSON) {
        const pollSelections = JSON.parse(storedPollSelectionsJSON);
        const pollId = this.props.id;
        const selectedOption = pollSelections[pollId];
        const ssoId = getCookie('ssoid');
        if (selectedOption !== undefined && ssoId) {
          const url = 'https://timesofindia.indiatimes.com/vote_json.cms';
          const postObjnew = `txtPolliD=${pollId}`;
          makeRequest.post(url, postObjnew).then(data => {
            this.setState({ selectedOption });
            this.setState({ showPollResult: true, pollResult: data.data });
          });
        }
      }
    } catch (error) {
      console.error(
        'An error occurred while retrieving the poll selections:',
        error,
      );
    }
  }

  submitPollResult = id => {
    // TODO: Change this once CORS is resolved
    const url = 'https://timesofindia.indiatimes.com/vote_json.cms';
    const postObj = {
      txtPolliD: parseInt(this.props.id, 10),
      PRadio: parseInt(id, 10),
    };
    const postObjnew = `txtPolliD=${postObj.txtPolliD}&PRadio=${
      postObj.PRadio
    }`;
    makeRequest.post(url, postObjnew).then(data => {
      this.setState({ showPollResult: true, pollResult: data.data });
      try {
        const storedPollSelections =
          JSON.parse(localStorage.getItem('pollSelections')) || {};
        storedPollSelections[postObj.txtPolliD] = this.state.selectedOption;
        localStorage.setItem(
          'pollSelections',
          JSON.stringify(storedPollSelections),
        );
      } catch (error) {
        console.error('Error updating poll selection:', error);
      }

      // Cookie.set(`POLLID`)
    });
  };

  selectOption = e => {
    const optionData = {
      id: e.id,
      value: e.name,
    };
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: `poll_widget`,
      category: 'option_select',
      msid: this.props?.msid || this.props?.id,
      page_title: this.props?.title || this.props?.hl,
      login_status: this.props?.isUserLoggedin,
    });

    this.setState({ selectedOption: optionData });
    this.submitPollResult(optionData.id);
  };

  getShowPollHtml() {
    const { options } = this.props;
    return (
      <>
        <div className={s.poll_inner}>
          <div className={s.pollAction}>
            {options instanceof Array &&
              options.map(val => {
                val = {
                  id: val.id || val.optionno,
                  name: val.name || val.description,
                };
                return (
                  <label
                    htmlFor={`${this.props.id}_${val.id}`}
                    className={
                      this.state.selectedOption &&
                      val.id === this.state.selectedOption.id &&
                      s.active
                    }
                  >
                    <input
                      type="radio"
                      name={this.props.id}
                      key={`${this.props.id}_${val.id}`}
                      value={val.name || val.description}
                      id={`${this.props.id}_${val.id}`}
                      onChange={() => this.selectOption(val)}
                    />
                    {val.name}
                  </label>
                );
              })}
          </div>
        </div>
      </>
    );
  }

  getPollResultHtml() {
    return (
      <PollResult
        selectedOption={this.state.selectedOption}
        data={this.state.pollResult}
      />
    );
  }

  getLoginPromptHtml() {
    return (
      <>
        <PollSuccessLoginBlocker
          toggleLoginBox={this.props.showLogin}
          ga4Type={this.props.ga4Type || 'poll_widget'}
          msid={this.props.msid || this.props.id}
          hl={this.props.hl}
          isWapView={this.props.isWapView || this.props.isMobile}
        />
      </>
    );
  }

  render() {
    // remove localStorage
    if (this.props.isWapView) {
      //return null;
    }
    let pollDone = '';
    if (typeof document !== 'undefined') {
      pollDone = Cookie.get(`POLLID${this.props.id}`);
    }

    return (
      // <div className={s.pollwidget}>
      <InViewObserver
        inViewCallback={() => {
          const isPollAlreadyDone = this.state?.showPollResult
            ? 'loggedin_polled'
            : 'loggedin_nonpolled';
          analyticsWrapper('ga4', {
            event: 'user_shown',
            category: `mid_article_embedded`,
            label: this.props?.isUserLoggedin
              ? isPollAlreadyDone
              : 'nonloggedin',
            type: `poll_widget`,
            msid: this.props?.msid || this.props?.id,
            page_title: this.props?.title || this.props?.hl,
            login_status: this.props?.isUserLoggedin,
          });
        }}
      >
        <div
          className={`${s.timeline_pollWrapper} timeline_pollWrapper_as ${
            this.state.showPollResult && !this.props.isUserLoggedin
              ? s.PollSuccessLoginBlocker
              : ''
          }`}
          data-scrollga="scroll#poll_view"
        >
          <div className={s.poll_mweb_fix}>
            <div className={s.poll_icons}>Poll</div>
            <div className={s.question}>
              {this.props.title || this.props.hl}
            </div>
            {!this.state.showPollResult && this.getShowPollHtml()}
            {(pollDone || this.state.showPollResult) &&
              this.props.isUserLoggedin &&
              this.getPollResultHtml()}
            {(pollDone || this.state.showPollResult) &&
              !this.props.isUserLoggedin &&
              this.getLoginPromptHtml()}
          </div>
        </div>
      </InViewObserver>
    );
  }
}

Polls.propTypes = {
  isWapView: PropTypes.bool,
  hl: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  id: PropTypes.string.isRequired,
  isUserLoggedin: PropTypes.bool.isRequired,
  showLogin: PropTypes.func.isRequired,
};

Polls.defaultProps = {
  isWapView: false,
};

export default Polls;
